import React, { useEffect, useState } from 'react';

export default function ImageUploadField({ label, existingImageUrl, onChange, required }) {
  const [preview, setPreview] = useState(existingImageUrl || '');

  useEffect(() => {
    setPreview(existingImageUrl || '');
  }, [existingImageUrl]);

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setPreview(URL.createObjectURL(file));
    onChange(file);
  }

  return (
    <div className="cs-admin_field">
      <label className="cs-admin_label">
        {label}
        {required ? ' *' : ''}
      </label>
      {preview && <img src={preview} alt="Preview" className="cs-admin_image_preview" />}
      <input type="file" accept="image/jpeg,image/png,image/webp" onChange={handleFileChange} />
    </div>
  );
}
